import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {
    Container,
    Row,
    Col,
    Form,
    FormField,
    FormNote,
    Input,
    Select,
    Button,
    Loader,
    Card,
    Alert
} from "kepler";
import { parseMessages } from '../../utilityHelper';
import { ENROLL_CHAR_COUNT } from '../../../../constants/constants';

const templateData = $('body').data();
const missionAreas = templateData.missionAreas;
const propertyInfo = parseMessages('directmodel/home');
const missionAreaContent = parseMessages('enrollment'); 

export default class DirecModel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            propertyInfo: propertyInfo,
            inputMissionAreaSelect: '',
            inputMissionAreaSecondSelect: '',
            inputMissionAreaThirdSelect: '',
            formData: false,
			loader: false,
			fileInfo: {},
            enrollStatus: templateData.enrollStatus
        };
        this.updateMissionAreaSelect = this.updateMissionAreaSelect.bind(this);
        this.updateMissionAreaSecondSelect = this.updateMissionAreaSecondSelect.bind(this);
        this.updateMissionAreaThirdSelect = this.updateMissionAreaThirdSelect.bind(this);
        this.enrollSubmit = this.enrollSubmit.bind(this);
        this.consentSubmit = this.consentSubmit.bind(this);
        this.readURL = this.readURL.bind(this);
    }

    updateMissionAreaSelect(option) {
        this.setState({
            inputMissionAreaSelect: option
        });
    }

    updateMissionAreaSecondSelect(option) {
        this.setState({
            inputMissionAreaSecondSelect: option
        });
    }

    updateMissionAreaThirdSelect(option) {
        this.setState({
            inputMissionAreaThirdSelect: option
        });
    }

    consentSubmit() {
        let csrf = $('body').attr('data-csrf');
        const self = this;
        self.setState({
            loader: true
        });
        let payload = {
            'state': 'confirmed',
            'consent_status': 'Y',
            _csrf: csrf
        }
       $.post('/givingfund/enroll/consentSubmit', payload, function(result) {
            if (result.submitResult) {
                self.setState({
                    enrollStatus: "completed",
                    loader: false
                });
                
            } else {
                $(".errorMsg").show();
                self.setState({
                    enrollStatus: "showConsent",
                    loader: false
                });
                
            }
            $(window).scrollTop(0);
		}).fail(function() {
			self.setState({
				searchResult: false,
				loader:false
			});
			$(window).scrollTop(0);
			
		})
    }

    enrollSubmit() {
        let csrf = $('body').attr('data-csrf');
        const self = this;
        self.setState({
            loader: true
        });

        let formObject = $("form").serializeObject();

        var uploadFile = $('#fileupload').prop('files');

        let arrageFormData = {
            keywords: formObject.keywords.trim(),
            missionAreaThird: self.state.inputMissionAreaThirdSelect,
            missionAreaSecond: self.state.inputMissionAreaSecondSelect,
            missionArea: self.state.inputMissionAreaSelect,
            fileupload: uploadFile,
            cta: formObject.cta.trim(),
            desc: formObject.desc.trim()
        }

        var form = $('form')[0];
        var formData = new FormData(form);
        formData.append('fileupload', uploadFile);
        formData.append('missionArea', self.state.inputMissionAreaSelect);
        formData.append('missionAreaSecond', self.state.inputMissionAreaSecondSelect);
        formData.append('missionAreaThird', self.state.inputMissionAreaThirdSelect);
        let isValidInput=this.validateEnrollFrom(arrageFormData);
        if (isValidInput) {
            let request = new XMLHttpRequest();
            request.open("POST", "/givingfund/enroll/submit");
            request.setRequestHeader('X-CSRF-Token', csrf);
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            request.onreadystatechange = function() {
                if (request.readyState == 4 && request.status == 200) {
                    let responseJson = JSON.parse(request.responseText);
                    if (responseJson.submitResult) {
                        self.setState({
                            loader: false,
                            enrollStatus: responseJson.enrollStatus
                        });
                    } else {
                        if (responseJson.case === 'ImageUpload') {
                            $(".errorMsg").show();
                        } else if (responseJson.case === 'updateCharityMissionAreas') {
                            $(".errorMsg").show();
                        } else if (responseJson.case === 'enrollDirectCharity') {
                            $(".errorMsg").show();
                        }
                        self.setState({
                            loader: false,
                            enrollStatus: responseJson.enrollStatus
                        });
                        
                    }
                    $(window).scrollTop(0);    
                } else {
                    self.setState({
                        loader: false,
                        enrollStatus: "confirmed"
                    });
                    $(window).scrollTop(0);
                }
            };
            request.send(formData);
        } else {
            event.preventDefault();
            self.setState({
                loader: false,
                enrollStatus: "confirmed"
            });
        }
    }

    isASCII(str) {
        return /^[\x00-\x7F]*$/.test(str);
    }

    validateEnrollFrom(data) {
       $("#descError, #descASCIIError, #ctaError, #ctaASCIIError,#missionAreaError, #keywordsError, #keywordsASCIIError, #uploadError, #uploadSizeError, #uploadTypeError").hide();
       var isValid = true;
       for (var key in data) {
            if (key == 'fileupload') {
                if (data[key].length == 0) {
                    $("#fileupload").focus();
                    $("#uploadError").show();
                    isValid = false;
                }
            } else {
                if (key == 'desc' || key == 'cta' || key == 'missionArea' || key == 'keywords') {
                    if (data[key] === '') {
                        $(`#${key}`).focus();
                        $(`#${key}`+'Error').show();
                        isValid = false;
                    } 
                }
            }
       }
       return isValid;
    }

    readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function(e) {
                //need this to get height and width of the image
                $('#userImg').attr('src', e.target.result);
                $('#div-plus').css('background-image', 'url(' + e.target.result + ')').addClass('hasImg').removeClass('noImg');
                $('.reqs').slideUp('fast');
            }
            reader.readAsDataURL(input.files[0]);
        } else if ($('#fileupload').val() !== '') {
            $('#div-plus').css('background', '').addClass('hasImg').removeClass('noImg');
        }
    }



    componentDidMount() {
        const self = this;
        $('#desc, #cta, #keywords').on("keyup", function () {
            let elementId = $(this).attr('id');
            let counterBox = (elementId === 'cta') ? 'ctaCounter' : (elementId === 'keywords') ? 'keywordsCounter' : 'descCounter';
            let maxLength = $(this).attr("maxLength");
            let textlen = maxLength - $(this).val().length;
            $('.' + counterBox).text(textlen);
        });
        $('input').keypress(function (e) {
            if (e.which == 13) {
                self.enrollSubmit();
                return false;
            }
        });

        $.fn.serializeObject = function () {
            const o = {};
            const a = this.serializeArray();
            $.each(a, function () {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        };

        $("#fileupload").change(function() {
            $("#uploadError, #uploadTypeError, #uploadSizeError").hide();
            //Validate File Type
            var file = $('#fileupload').val();
            var exts = ['jpg','png','gif'];
            var get_ext = file.split('.');
            get_ext = get_ext.reverse();
            if ( $.inArray ( get_ext[0].toLowerCase(), exts ) === -1 ){
                $('#fileupload').val('');
                $("#uploadTypeError").show();
                return false
            }

            //Validate File Size
            var file_size = $(this)[0].files[0].size;
            if(file_size>512000) {
                $('#fileupload').val('');
                $("#uploadSizeError").show();
                return false;
            }

            self.readURL(this);
            if (document.imgUpload && document.imgUpload.submitType.value === 'Update') {
                document.imgUpload.submit();
            }
        });

        $('.noImg').on({
            mouseenter: function(e) {
                if ($(this).hasClass('hasImg')) {
                    $('.uploadOver').show();
                } else {
                    $('.reqs').slideDown('fast');
                }
            },
            mouseleave: function(e) {
                if ($(this).hasClass('hasImg')) {
                    $('.uploadOver').hide();
                } else {
                    $('.reqs').slideUp('fast');
                }
            }
        });

        $('.remove').click(function() {
            $('#div-plus').css('background', '').addClass('noImg').removeClass('hasImg');
            $('#fileupload').val('');
            $('.uploadOver').hide();
            return false;
        });
        // change previously uploaded image
        $('.change').click(function() {
            $('#fileupload').trigger('click');
            return false;
        });
    }
    render() {
        let missionAreasOptions = missionAreas.map(function (missionarea) {
            let missionAreaLabel = missionAreaContent[missionarea.id] ? missionAreaContent[missionarea.id] : missionarea.name;
            return {
                label: missionAreaLabel,
                value: missionarea.id
            };
        });
        let enrollStatus = this.state.enrollStatus,
            descriptionBottomnote = propertyInfo.directmodel.enroll.description.bottomnote.replace(/511/g, ENROLL_CHAR_COUNT.DESCRIPTION),
            ctaBottomnote = propertyInfo.directmodel.enroll.cta.bottomnote.replace(/90/g, ENROLL_CHAR_COUNT.SLOGAN),
            keywordsBottomnote = propertyInfo.directmodel.enroll.keywords.bottomnote.replace(/255/g, ENROLL_CHAR_COUNT.KEYWORDS);
        return (
            <div id="directModelWrapper">
                <Loader show={this.state.loader} priority={10} type="fixed" size="lg" opacity={0.5}></Loader>
                <Container className="container">
                    {(enrollStatus == "completed") ? <Card className="enroll completed">
                        <Row className="rowMargin">
                            <Col>
                                <p className="textcenter"><img src="https://www.paypalobjects.com/webstatic/ppgf/check.png" /></p>
                                <h3>{propertyInfo.directmodel.success.header}</h3>
                                <p  className="vx_text-body-md successmessage">{propertyInfo.directmodel.success.info}</p>
                                <Button href="/" submit>{propertyInfo.directmodel.success.continue}</Button>
                            </Col>
                        </Row>
                    </Card> : 
                    (enrollStatus == "showConsent") ? <Card className="enroll showconsent">
                        <Alert type="error" className="errorMsg" style={{ 'display': 'none' }}>{ ReactHtmlParser(propertyInfo.directmodel.enroll.errorMsg) }</Alert>
                        <Row className="rowMargin">
                            <Col className="consentStmt"> {propertyInfo.directmodel.consent.header}</Col>
                        </Row>
                        <Row className="rowMargin">
                            <Col>
                                <div className="consentStmt"> 
                                    <p><h4>{propertyInfo.directmodel.consent.note1}</h4></p>
                                    <p>{propertyInfo.directmodel.consent.subnote}</p>
                                    <ul className="agreement">
                                        <li>{propertyInfo.directmodel.consent.note1a}</li>
                                        <li>{ ReactHtmlParser(propertyInfo.directmodel.consent.note1b) }</li>
                                        <li>{propertyInfo.directmodel.consent.note1c}</li>
                                        <li>{propertyInfo.directmodel.consent.note1d}</li>
                                        <li>{propertyInfo.directmodel.consent.note1e}</li>
                                        <li>{ ReactHtmlParser(propertyInfo.directmodel.consent.note1f) }</li>
                                    </ul>
                                    <p>{propertyInfo.directmodel.consent.bottomnote1}</p>
                                    <p><h4>{propertyInfo.directmodel.consent.note2}</h4></p>
                                    <ul className="agreement">
                                        <li>{propertyInfo.directmodel.consent.note2a}</li>
                                        <li>{propertyInfo.directmodel.consent.note2b }</li>
                                        <li>{ ReactHtmlParser(propertyInfo.directmodel.consent.note2c) }</li>
                                    </ul>
                                    <p>{propertyInfo.directmodel.consent.bottomnote2}</p>
                                    <p><h4>{propertyInfo.directmodel.consent.note3}</h4></p>
                                    <ul className="agreement">
                                        <li>{propertyInfo.directmodel.consent.note3a}</li>
                                    </ul>
                                    <p>{propertyInfo.directmodel.consent.bottomnote3}</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className="rowMargin">
                            <Col>
                            <Button onClick={this.consentSubmit} id="consentSubmit" submit>{propertyInfo.directmodel.consent.continue}</Button>
                            </Col>
                        </Row>
                    </Card> :
                        <Card className="enroll">
                            <Alert type="error" className="errorMsg" style={{ 'display': 'none' }}>{ ReactHtmlParser(propertyInfo.directmodel.enroll.errorMsg) }</Alert>
                            <Row className="rowMargin">
                                <Col><h1>{propertyInfo.directmodel.enroll.header}</h1></Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form>
                                        <FormField label={propertyInfo.directmodel.enroll.label.charitydesc} htmlFor="basic-form-input-email">
                                            <FormNote>
                                                {propertyInfo.directmodel.enroll.description.note}
                                            </FormNote>
                                            <Input placeholder={propertyInfo.directmodel.enroll.description.placeholder} id="desc" name="desc" multiline maxLength={ENROLL_CHAR_COUNT.DESCRIPTION} />
                                            <div id="descError">{propertyInfo.directmodel.enroll.description.error}</div>
                                            <div id="descASCIIError">{propertyInfo.directmodel.enroll.warnASCII}</div>
                                            <FormNote className="bottomnote">
                                                { ReactHtmlParser(descriptionBottomnote) }
                                            </FormNote>
                                        </FormField>
                                        <FormField label={propertyInfo.directmodel.enroll.label.cta} htmlFor="basic-form-input-email">
                                            <FormNote>
                                                {propertyInfo.directmodel.enroll.cta.note}
                                            </FormNote>
                                            <Input placeholder={propertyInfo.directmodel.enroll.cta.placeholder} id="cta" name="cta" multiline maxLength={ENROLL_CHAR_COUNT.SLOGAN} />
                                            <div id="ctaError">{propertyInfo.directmodel.enroll.cta.error}</div>
                                            <div id="ctaASCIIError">{propertyInfo.directmodel.enroll.warnASCII}</div>
                                            <FormNote className="bottomnote">
                                                { ReactHtmlParser(ctaBottomnote) }
                                            </FormNote>
                                        </FormField>
                                        <FormField label={propertyInfo.directmodel.enroll.uploadlogo.title} htmlFor="basic-form-input-email">
                                             <FormNote>
                                             {propertyInfo.directmodel.enroll.uploadlogo.note}
                                            </FormNote>
                                            <div className="upload">
                                                <img id="userImg" src="" />
                                                <div className="plus-padding">
                                                    <div id="div-plus" className="plus noImg">
                                                        <label className="boxContent" htmlFor="fileupload">
                                                            <span className="plusSign">+</span>
                                                            <div className='text'>{propertyInfo.directmodel.enroll.uploadlogo.placeholder}</div>
                                                        </label>
                                                        <div className="uploadOver">
                                                            <div className="trans">
                                                                <p className="title">
                                                                    <span className="imgName"></span> <br />
                                                                    <span className="imgSize"></span>
                                                                </p>
                                                                <a href="#" className="remove">{propertyInfo.directmodel.enroll.uploadlogo.remove}</a>
                                                                <a href="#" className="change">{propertyInfo.directmodel.enroll.uploadlogo.replace}</a>
                                                            </div>
                                                        </div>

                                                        <input type="file" id="fileupload" name="fileupload" label=""/>

                                                    </div>
                                                </div>
                                            </div>
                                            <div id="uploadError">{propertyInfo.directmodel.enroll.uploadlogo.error}</div>
                                            <div id="uploadSizeError">{propertyInfo.directmodel.enroll.uploadlogo.sizeerror}</div>
                                            <div id="uploadTypeError">{propertyInfo.directmodel.enroll.uploadlogo.typeerror}</div>
                                            <FormNote className="bottomnote">
                                                {propertyInfo.directmodel.enroll.uploadlogo.bottomnote}
                                            </FormNote>
                                        </FormField>
                                        <FormField label={propertyInfo.directmodel.enroll.missionarea.title} htmlFor="basic-form-input-email">
                                            <FormNote>
                                            {propertyInfo.directmodel.enroll.missionarea.note}
                                            </FormNote>
                                        </FormField>
                                        <FormField label={propertyInfo.directmodel.enroll.primarymissionarea.title} htmlFor="basic-form-input-email">
                                            <Select
                                                name="missionArea"
                                                id="missionArea"
                                                label={missionAreaContent.enrollment.selectCauseArea}
                                                options={missionAreasOptions}
                                                onChange={this.updateMissionAreaSelect}
                                                placeholder={missionAreaContent.enrollment.selectCauseArea}
                                                leftPadding="3.5em"
                                                rightPadding="3em"
                                                value={this.state.inputMissionAreaSelect}
                                            />
                                            <div id="missionAreaError">{propertyInfo.directmodel.enroll.primarymissionarea.error}</div>
                                        </FormField>
                                        <FormField label={propertyInfo.directmodel.enroll.secondarymissionarea.title} htmlFor="basic-form-input-email">
                                            <Select
                                                name="missionAreaSecond"
                                                id="missionAreaSecond"
                                                label={missionAreaContent.enrollment.selectCauseArea}
                                                options={missionAreasOptions}
                                                onChange={this.updateMissionAreaSecondSelect}
                                                placeholder={missionAreaContent.enrollment.selectCauseArea}
                                                leftPadding="3.5em"
                                                rightPadding="3em"
                                                value={this.state.inputMissionAreaSecondSelect}
                                            />
                                        </FormField>
                                        <FormField htmlFor="basic-form-input-email">
                                            <Select
                                                name="missionAreaThird"
                                                id="missionAreaThird"
                                                label={missionAreaContent.enrollment.selectCauseArea}
                                                options={missionAreasOptions}
                                                onChange={this.updateMissionAreaThirdSelect}
                                                placeholder={missionAreaContent.enrollment.selectCauseArea}
                                                leftPadding="3.5em"
                                                rightPadding="3em"
                                                value={this.state.inputMissionAreaThirdSelect}
                                            />
                                        </FormField>
                                        <FormField label={propertyInfo.directmodel.enroll.keywords.title} htmlFor="basic-form-input-email">
                                            <FormNote>
                                            {propertyInfo.directmodel.enroll.keywords.note}
                                            </FormNote>
                                            <Input placeholder={propertyInfo.directmodel.enroll.keywords.placeholder} id="keywords" name="keywords" multiline maxLength={ENROLL_CHAR_COUNT.KEYWORDS} />
                                            <div id="keywordsError">{propertyInfo.directmodel.enroll.keywords.error}</div>
                                            <div id="keywordsASCIIError">{propertyInfo.directmodel.enroll.warnASCII}</div>
                                            <FormNote className="bottomnote">
                                                { ReactHtmlParser(keywordsBottomnote) }
                                            </FormNote>
                                        </FormField>
                                        <Button onClick={this.enrollSubmit} id="enrollSubmit">{propertyInfo.directmodel.enroll.continue}</Button>
                                    </Form>
                                </Col>
                            </Row>
                        </Card>
                    }
                </Container>
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./directmodel/components/enroll.js